
// MANN – Delayed / Minimal Sticky Header behavior for Dawn
// - Non-home pages: optional delayed header (hide on first load, show after scroll down + scroll up).
// - Home page: either same behavior as others or a minimal mode with a floating hamburger only,
//   where the floating hamburger itself can also be delayed.

/**
 * Configuration
 */// MANN homepage: hide header at top, reveal only after scroll down past minDown and then scroll up.
// Then let Dawn handle normal "On scroll up" behavior.
// When returning to top, hide again.

document.addEventListener('DOMContentLoaded', function () {
  // Only run on homepage
  var path = window.location.pathname || '/';
  var isHome = (path === '/' || path === '/index.html');
  if (!isHome) return;

  var header = document.querySelector('.header-wrapper');
  if (!header) return;

  var minDown = 450;       // your threshold
  var topHideOffset = 10;  // treat <= this as "top"
  var deadzone = 8;        // ignore tiny scroll jitter (prevents flicker)

  // If the homepage tag added the class, we start hidden.
  // If not present, we still enforce the "top hidden" rule.
  var unlocked = !header.classList.contains('mann-header-initial-hidden');
  var lastY = window.scrollY || 0;

  function hideHeader() {
    if (!header.classList.contains('mann-header-initial-hidden')) {
      header.classList.add('mann-header-initial-hidden');
    }
    unlocked = false;
  }

  function showHeader() {
    header.classList.remove('mann-header-initial-hidden');
    unlocked = true;

    // Help Dawn re-measure header height + sticky bounds after being display:none
    window.dispatchEvent(new Event('resize'));
  }

  // Always hide if we're at the very top
  if (lastY <= topHideOffset) hideHeader();

  window.addEventListener('scroll', function () {
    var y = window.scrollY || 0;
    var dy = y - lastY;

    // Ignore tiny scroll movements to avoid flicker
    if (Math.abs(dy) < deadzone) {
      lastY = y;
      return;
    }

    // If at top, always hide and "lock" again
    if (y <= topHideOffset) {
      hideHeader();
      lastY = y;
      return;
    }

    // Not unlocked yet: only unlock after passing minDown and then scrolling UP
    if (!unlocked) {
      var scrollingUp = dy < 0;
      if (scrollingUp && y > minDown) {
        showHeader();
      }
    }

    // After unlock: we do NOT force-hide on scroll down.
    // Dawn's "On scroll up" will hide it on downward scroll.
    // We only re-hide when user returns to top (handled above).

    lastY = y;
  }, { passive: true });
});